import { createFileRoute, redirect } from "@tanstack/react-router"
import { CalendarPage } from "./-components/CalendarPage"

export const Route = createFileRoute("/app/my/calendar/")({
  beforeLoad: (context) => {
    if (
      !context.context.authStatus?.loggedIn ||
      !context.context.permittedRoutes.find(
        (x) => x.route === context.location.pathname
      )
    ) {
      throw redirect({ to: "/app/my/calendar-subscriptions" })
    }
  },
  component: CalendarPage,
})
